import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { realCosts } from '../data/offer';
const questions = ['Should you work on timing?', "Should you repeat last week's combination?", 'Do they need more technique before progressing?', 'How do you make the class challenging without making it frustrating?', 'What can you do differently so the session does not feel exactly like the last one?'];
export function PainPoints() {
  return <section className="border-t border-acad-line bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-124" data-mp="21z35kzpo08l4">
      <div className="mx-auto max-w-3xl" data-id="element-125" data-mp="21x08xwu0bh7f">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-126" data-mp="1o0lnbhij3oal">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-127" data-mp="1z05c9f03fd4d">
            A familiar teaching problem
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-128" data-mp="1u1bu399v2xxv">
            Does this sound familiar?
          </h2>
          <div className="mt-7 rounded-2xl border border-acad-line bg-white p-6 text-left text-base leading-7 text-acad-muted shadow-card sm:p-8" data-id="element-129" data-mp="23rn7dmffqjhf">
            <p data-id="element-130" data-mp="1g2cf6tc5hxew">
              You have another Tap Dance class tomorrow. You know your students.
              You know the technique. You know what they need to improve.
            </p>
            <p className="mt-4" data-id="element-131" data-mp="1p3aamn8iwwlv">
              But you are still searching through old notes, videos,
              combinations, saved ideas, and scattered resources trying to decide
              what tomorrow&apos;s class should actually look like.
            </p>
            <ul className="mt-5 space-y-2 border-l-2 border-acad-gold pl-5" data-id="element-132" data-mp="2vj2vxm0jygaa">
              {questions.map(question => <li key={question} className="text-sm font-medium text-acad-ink" data-id="element-133" data-mp="1t4decvnf6w55">
                  {question}
                </li>)}
            </ul>
            <p className="mt-5" data-id="element-134" data-mp="2263662l7rx3g">
              And before you realize it, another hour is gone.
            </p>
            <p className="mt-4" data-id="element-135" data-mp="275g017ai64fj">
              <strong className="font-semibold text-acad-ink" data-id="element-136" data-mp="274ef8b3oq3km">
                Not because you do not know Tap Dance. Because you have been
                forced to build too much of your teaching system yourself.
              </strong>
            </p>
            <p className="mt-4" data-id="element-137" data-mp="1jflqaylhcvzi">
              The problem is not your knowledge. The problem is having to
              transform that knowledge into organized, progressive, engaging
              classes every single week.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-138" data-mp="qotx89zponge">
          <h3 className="text-center text-xl font-semibold text-acad-ink" data-id="element-139" data-mp="vp9db9bdo922">
            The real cost of teaching without a complete system:
          </h3>
          <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-140" data-mp="o45ouiea7cgu">
            {realCosts.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.24,
            delay: Math.min(index, 5) * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex items-start gap-3 rounded-xl border border-acad-line bg-acad-sand/60 px-5 py-4 text-sm leading-6 text-acad-muted" data-id="element-141" data-mp="j5cc4s6tjphq" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-acad-goldDark" aria-hidden="true" data-id="element-142" data-mp="3ilhbsiw10h82" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-acad-gold/55 pt-8 text-center" data-id="element-143" data-mp="1llefl0dw3plo">
            <p className="font-display text-2xl font-semibold leading-snug text-acad-ink sm:text-3xl" data-id="element-144" data-mp="17u9edtuvip98">
              Stop using your free time to rebuild the same teaching work every
              week.
            </p>
            <p className="mt-4 text-base leading-7 text-acad-muted" data-id="element-145" data-mp="xvk70v0lsn78">
              You already bring the knowledge. You already bring the experience.
              You already bring the energy.
            </p>
            <p className="mt-3 text-lg font-semibold text-acad-gold" data-id="element-146" data-mp="ow5hbxs9ggns">
              Tap Dance Teacher Ready gives you the system.
            </p>
          </div>
        </div>
      </div>
    </section>;
}